export let dirs = {
	STATIC_ROOT: '/',
	WWW_ROOT: '/'
};

export let jsClasses = {
	fs: {
		swapActive: 'fs-swap-active'
	}
};

export let requireAll = (context) => {
	context.keys().forEach(context);
};
